import { useQuery } from '@tanstack/react-query';
import { fetchRecords } from '../../messages/services/MessagesService';
import { Message } from '../../messages/types';

export const useAllMessages = () => {
    const fetchAllMessages = async (): Promise<Message[]> => {
        const allMessages: Message[] = [];
        let nextToken: string | null = null;

        do {
            const result = await fetchRecords({ limit: 100, nextToken });
            if (result && result.items) {
                allMessages.push(...result.items);
            }
            nextToken = result?.nextToken || null;
        } while (nextToken);

        return allMessages;
    };

    const query = useQuery({
        queryKey: ['all-messages'],
        queryFn: fetchAllMessages,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });

    return {
        items: query.data || [],
        loading: query.isLoading,
        refetch: query.refetch,
    };
};
